import * as d3 from 'd3';

export class PaneTitle {
    constructor(container: d3.Selection<any>) {
        this._group = container;

        this._group.append('text')
            .classed('fa-icon', true)
            .attr('y', 0)
            .attr('dy', '0.85em');
        this._group
            .append('g')
            .classed('title-text-container', true)
            .append('text')
            .classed('title-text', true)
            .attr('y', 0)
            .attr('dy', '0.85em');
    }

    private _group: d3.Selection<any>;
    group(): d3.Selection<any> {
        return this._group;
    }

    private _faIcon: string;
    faIcon(): string;
    faIcon(value: string): this;
    faIcon(value?: string): this | string {
        if (arguments.length) {
            this._faIcon = value;
            return this;
        }
        return this._faIcon;
    }

    private _isLeftAligned: boolean;
    isLeftAligned(): boolean;
    isLeftAligned(value: boolean): this;
    isLeftAligned(value?: boolean): this | boolean {
        if (arguments.length) {
            this._isLeftAligned = value;
            return this;
        }
        return this._isLeftAligned;
    }

    private _isVisible: boolean;
    isVisible(): boolean;
    isVisible(value: boolean): this;
    isVisible(value?: boolean): this | boolean {
        if (arguments.length) {
            this._isVisible = value;
            return this;
        }
        return this._isVisible;
    }

    private _iconClickCallback: () => void;
    iconClickCallback(): (() => void);
    iconClickCallback(value?: () => void): this;
    iconClickCallback(value?: () => void): this | (() => void) {
        if (arguments.length) {
            this._iconClickCallback = value;
            return this;
        }
        return this._iconClickCallback;
    }

    private _textClickCallback: () => void;
    textClickCallback(): (() => void);
    textClickCallback(value?: () => void): this;
    textClickCallback(value?: () => void): this | (() => void) {
        if (arguments.length) {
            this._textClickCallback = value;
            return this;
        }
        return this._textClickCallback;
    }

    private _text: string;
    text(): string;
    text(value: string): this;
    text(value?: string): this | string {
        if (arguments.length) {
            this._text = value;
            return this;
        }
        return this._text;
    }

    private _attr: { [key: string]: any; };
    attr(): { [key: string]: any; };
    attr(value: { [key: string]: any; }): this;
    attr(value?: { [key: string]: any; }): this | { [key: string]: any; } {
        if (arguments.length) {
            this._attr = value;
            return this;
        }
        return this._attr;
    }

    render(): void {
        this._group
            .classed('hidden', !this._isVisible)
            .select('.title-text-container')
            .attr(this._attr)
            .on('click', () => {
                if (this._textClickCallback) {
                    this._textClickCallback();
                }
            })
            .select('text.title-text')
            .classed('clickable', !!this._textClickCallback)
            .text(this._text)
            .attr('x', this._faIcon ? '12' : null)
            .classed('centered', !this._isLeftAligned);
        this._group
            .select('text.fa-icon')
            .classed('clickable', !!this._iconClickCallback)
            .classed('hidden', !this._faIcon || !this._isLeftAligned) // display will be screwed up if icon and center
            .text(this._faIcon)
            .on('click', () => {
                if (this._iconClickCallback) {
                    this._iconClickCallback();
                }
            });
    }
}
